import { useEffect, useState } from 'react';

import type { NotificationStatus } from './types';

const YEKB = 'Asia/Yekaterinburg';

const stampFormat = new Intl.DateTimeFormat('sv-SE', {
    timeZone: YEKB,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
});

export const nowYekb = (): string =>
    stampFormat.format(new Date()).replace('T', ' ').slice(0, 16);

export const stamp = (date?: string | null, time?: string | null): string => {
    const day = (date ?? '').trim();
    if (!day || day === 'None') return '';

    const raw = (time ?? '').trim();
    const clock = !raw || raw === 'None' ? '00:00' : raw.slice(0, 5);

    return `${day} ${clock}`;
};

export interface TimeWindow {
    startsAt: string;
    endsAt: string;
}

export const isActive = (item: TimeWindow, now: string = nowYekb()): boolean =>
    Boolean(item.startsAt) && Boolean(item.endsAt) && item.startsAt <= now && now <= item.endsAt;

export const statusOf = (item: TimeWindow, now: string = nowYekb()): NotificationStatus => {
    if (!item.startsAt && !item.endsAt) return 'unknown';
    if (item.startsAt && now < item.startsAt) return 'planned';
    if (item.endsAt && now > item.endsAt) return 'done';
    return 'active';
};

export const formatYekb = (value?: string | null, withZone = false): string => {
    const raw = (value ?? '').trim();
    if (!raw) return '';

    const [date = '', time = ''] = raw.split(' ');
    const [year, month, day] = date.split('-');
    if (!year || !month || !day) return raw;

    const clock = time.slice(0, 5);
    const zone = withZone ? ' (GMT+5)' : '';

    return clock ? `${day}.${month}.${year}, ${clock}${zone}` : `${day}.${month}.${year}`;
};

const TICK_MS = 30_000;
export const useNowYekb = (): string => {
    const [now, setNow] = useState(nowYekb);

    useEffect(() => {
        const timer = window.setInterval(() => setNow(nowYekb()), TICK_MS);
        return () => window.clearInterval(timer);
    }, []);

    return now;
};